import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/rules-documents',
  component: Layout,
  name: 'RulesDocuments',
  meta: {
    title: '规则&文档',
    icon: 'i-ant-design:snippets-outlined',
    auth: [],
  },
  children: [
    {
      path: '/rules-documents/development-rule/index',
      name: 'DevelopmentRuleIndex',
      component: () => import('@/views/development-rule/index.vue'),
      meta: {
        title: '开发规则',
        icon: 'i-ant-design:file-protect-outlined',
        auth: 'development-rule:list',
      },
    },
    {
      path: '/rules-documents/project-document/index',
      name: 'ProjectDocumentIndex',
      component: () => import('@/views/project-document/index.vue'),
      meta: {
        title: '项目文档',
        icon: 'i-ant-design:read-outlined',
        auth: 'project-document:list',
      },
    },
    {
      path: '/rules-documents/project-document-history/index',
      name: 'ProjectDocumentHistoryIndex',
      component: () => import('@/views/project-document-history/index.vue'),
      meta: {
        title: '文档变更审计',
        icon: 'i-ant-design:history-outlined',
        auth: 'project-document-history:list',
      },
    },
    {
      path: '/rules-documents/project-document-change/index',
      redirect: '/rules-documents/project-document-history/index?tab=requests',
      meta: {
        title: '文档修改',
        auth: 'project-document-history:list',
        menu: false,
      },
    },
    {
      path: '/rules-documents/development-rule/detail/:id',
      name: 'DevelopmentRuleDetail',
      component: () => import('@/views/development-rule/detail.vue'),
      meta: {
        title: '开发规则详情',
        auth: 'development-rule:list',
        menu: false,
        activeMenu: '/rules-documents/development-rule/index',
      },
    },
    {
      path: '/rules-documents/project-document/detail/:id',
      name: 'ProjectDocumentDetail',
      component: () => import('@/views/project-document/detail.vue'),
      meta: {
        title: '项目文档详情',
        auth: 'project-document:list',
        menu: false,
        activeMenu: '/rules-documents/project-document/index',
      },
    },
    {
      path: '/rules-documents/project-document/detail/:documentId/file/:fileId',
      name: 'ProjectDocumentFileEdit',
      component: () => import('@/views/project-document/file-edit.vue'),
      meta: {
        title: '项目文档文件',
        auth: 'project-document:list',
        menu: false,
        activeMenu: '/rules-documents/project-document/index',
      },
    },
  ],
}

export default routes
